import { TableHeader, TableHeaderCell } from '@hivewatch/dark'

import type { DarkIncidentColumn } from '../types'

export const IncidentsTableHeader = ({
  columns,
}: {
  columns: DarkIncidentColumn[]
}) => (
  <TableHeader>
    {columns.map((column) => (
      <TableHeaderCell
        column={column.sortColumn}
        key={column.key}
        sortBadge={column.sortBadge}
        sortOrder={column.sortOrder}
        {...column.style}
      >
        {column.header}
      </TableHeaderCell>
    ))}
  </TableHeader>
)
